import { Checkbox, Col, DatePicker, Input, Row, Upload, Modal } from "antd";
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import AdminModal from "./AdminModal";
import PreviewImgModal from './Media/PreviewImgModal';
import dayjs from 'dayjs'
import { useState } from "react";
import { useEffect } from "react";
import axios from 'axios';
const { confirm } = Modal;

const AdminTeacherModal = (props) => {
    const [check, setCheck] = useState(false);
    const [blog_check, set_blog_check] = useState(false);
    const [blog_filelist, set_blog_filelist] = useState([]);
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    // useEffect(() => {
    //     // setCheck(false);
    //     // set_blog_check(false);
    //     console.log(props.editcard);
    // }, [props.editcard]);
    // useEffect(() => {
    //     const keyDownHandler = event => {
    //         // console.log('User pressed: ', event.key);

    //         if (event.key === 'Enter') {
    //             // event.preventDefault();

    //             // 👇️ call submit function here
    //             // props.edit ? props.handleEdit(fileList.map(map_item => map_item.uid)) : props.handleSubmit(fileList.map(map_item => map_item.uid))
    //         }
    //     };

    //     document.addEventListener('keydown', keyDownHandler);

    //     return () => {
    //         document.removeEventListener('keydown', keyDownHandler);
    //     };
    // }, []);
    useEffect(() => {
        if (JSON.stringify(props.editcard) == '{}') {
            // console.log(props.editcard?.blog_data.length); 
            set_blog_check(false);
        }
        // else if (props.editcard.blog_data != undefined && props.editcard.blog_data.length == 0) {
        // set_blog_check(false);
        // }
        // if (JSON.stringify(props.editcard) != '{}' && props.editcard.blog_data.length != 0) {
        //     setCheck(true)
        // }
        // console.log(props.editcard)
        // if (props.editcard.blog_data?.length != undefined && props.editcard.blog_data?.length != 0) {
        //     set_blog_check(true);
        // }else{
        // set_blog_check(false);
        // }
    }, [props.editcard])
    const handleUpload = (e) => {
        e = e.file;
        let form_data = new FormData();
        form_data.append('inputFile', e);
        axios
            .post(`/cramSchool/api/file`, form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                set_blog_filelist(
                    prev => {
                        return ([
                            ...prev,
                            {
                                uid: file_id,
                                url: dataurl
                            }
                        ])
                    }
                );
            })
    }
    // useEffect(() => {
    //     // setFileList([]);
    //     // const data_tmp = [];
    //     // props.editcard.file_id && props.editcard.file_id.forEach((element, i) => {
    //     //     if (props.editcard.file_url != undefined) {
    //     //         data_tmp.push({ uid: element, url: props.editcard.file_url[i] })
    //     //     }
    //     // })
    //     // setFileList(data_tmp)

    // }, [props.editcard['file_url']])
    const showConfirm = (e) => {
        confirm({
            title: '確認要刪除此張圖片嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(e);
            },
        });
    };
    const handlePreview = (e) => {
        setImg(e.url);
        set_modal_img(true);
    }
    const remove = (e) => {
        set_blog_filelist(prev => prev.filter(filter_item => filter_item.uid !== e.uid));
    }
    useEffect(() => {
        props.setEditCard(pre => ({ ...pre, blog: blog_check == true ? 'check' : 'not_check' }))
    }, [blog_check])
    useEffect(() => {
        props.setEditCard(pre => ({ ...pre, administration: check ? 'check' : 'not_check' }))
    }, [check])
    useEffect(() => {
        props.setEditCard(pre => ({
            ...pre,
            blog_file_id: blog_filelist.map(map_item => map_item.uid)
        }))
    }, [blog_filelist])
    return (<>
        <PreviewImgModal
            modal_img={modal_img}
            set_modal_img={set_modal_img}
            img={img}
        ></PreviewImgModal>
        <AdminModal
            {...props}
            title={(<>
                <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
            </>)}
            uploads
        >
            <Row gutter={[16, 8]} align={'middle'}>
                <Col span={24}>
                    <Row align={'end'}>
                        {/* {blog_check ?
                            <Col>是/否顯示</Col>
                            : null} */}
                    </Row>
                </Col>
                {/* <Col span={6}>姓名</Col>
                <Col span={18}>
                <Input style={{ width: 180 }} placeholder={'請輸入教師姓名(必填)'} type='text' value={props.editcard.teacher_name} name="teacher_name" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_name: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>任教系所(單位)</Col>
                <Col span={18}>
                <Input style={{ width: 180 }} placeholder={'請輸入教師任教系所(單位)（必填)'} type='text' value={props.editcard.teacher_expertise} name="teacher_expertise" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_expertise: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>聯絡電話</Col>
                <Col span={18}>
                <Input style={{ width: 180 }} placeholder={'請輸入教師電話(必填)'} type='text' value={props.editcard.teacher_phone} name="teacher_phone" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_phone: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>老師電子信箱</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入老師電子信箱'} type='email' value={props.editcard && props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>手機</Col>
                <Col span={18}>
                <Input style={{ width: 180 }} placeholder={'請輸入教師手機'} type='text' value={props.editcard.teacher_cellphone} name="teacher_cellphone" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_cellphone: e.target.value }))} />
                </Col> */}
                {/* <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}> */}
                <Col span={6}>老師姓名</Col>
                <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入教師姓名(必填)'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} />
                </Col>
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                {/* {props.edit ? <> */}
                <Col span={6}>任教系所(單位)</Col>
                <Col span={18}>
                <Input style={{ width: 300 }} placeholder={'請輸入教師任教系所(單位)（必填)'} type='text' value={props.editcard.school_u_work} name="school_u_work" onChange={e => props.setEditCard(prev => ({ ...prev, school_u_work: e.target.value }))} />
                    {/* <label>{props.editcard['serial_name']}</label> */}
                </Col>
                {/* </> : null} */}
                <Col span={6}>聯絡電話</Col>
                <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入教師電話(必填)'} type='text' value={props.editcard.expersite} name="expersite" onChange={e => props.setEditCard(pre => ({ ...pre, expersite: e.target.value }))} />
                </Col>
                <Col span={6}>老師電子信箱</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入老師電子信箱(必填)'} type='email' value={props.editcard && props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                </Col>
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                <Col span={6}>手機</Col>
                <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入教師手機'} type='text' value={props.editcard.phone} name="phone" onChange={e => props.setEditCard(pre => ({ ...pre, phone: e.target.value }))} />
                </Col>
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                {/* <Col span={6}>老師電子信箱</Col>
                <Col span={15}>
                    <Input placeholder={'請輸入老師電子信箱'} type='email' value={props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                </Col> */}
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                {/* <Col span={6}>老師地址</Col>
                <Col span={15}>
                    <Input placeholder={'請輸入老師地址'} type='text' value={props.editcard.address} name="address" onChange={e => props.setEditCard(pre => ({ ...pre, address: e.target.value }))} />
                </Col> */}
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                {/* <Col span={6}>老師入職時間</Col> */}
                {/* <Col span={15}> */}
                    {/* <DatePicker style={{ width: '100%' }}
                        value={props.editcard.employment_time_start != '' && props.editcard.employment_time_start != null ? dayjs(props.editcard.employment_time_start, 'YYYY-MM-DD') : null}
                        format={'YYYY-MM-DD'}
                        onChange={(date, dateString) => {
                            props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'employment_time_start': dateString,
                                    }
                                )
                            }
                            )
                        }}
                    /> */}
                {/* </Col> */}
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                {/* <Col span={6}>老師離職時間</Col>
                <Col span={15}> */}
                    {/* <DatePicker style={{ width: '100%' }}
                        value={props.editcard.employment_time_end != '' && props.editcard.employment_time_end != null ? dayjs(props.editcard.employment_time_end, 'YYYY-MM-DD') : null}
                        format={'YYYY-MM-DD'}
                        onChange={(value, dateString) => props.setEditCard(preState => {
                            return (
                                {
                                    ...preState,
                                    'employment_time_end': dateString,
                                }
                            )
                        })}
                    /> */}
                {/* </Col> */}
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                <Col span={6}>備註</Col>
                <Col span={15}>
                    <Input.TextArea rows={4} type='text' value={props.editcard.note} name="note" placeholder="請輸入老師介紹或個人名言" onChange={e => props.setEditCard(pre => ({ ...pre, note: e.target.value }))} />
                </Col>
                {/* {blog_check ?
                    <Col span={3}>
                        <Row align={'center'}>
                            <Checkbox></Checkbox>
                        </Row>
                    </Col> : null} */}
                {/* {props.edit != true ? <> */}

                {/* <Col span={9}>是否發布到形象網站</Col> */}
                {/* <Col span={15}> */}
                    {/* {props.editcard['blog_data']?.length != 0 ? <> */}
                    {/* <Checkbox
                        checked={blog_check} onChange={e => {
                            set_blog_check(!blog_check);
                        }}>是</Checkbox> */}
                    {/* </> :
                        <Checkbox
                            checked={true} disabled>是</Checkbox>} */}

                {/* </Col> */}
                {/* {blog_check ? <>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Input placeholder={'請輸入文章標題'} type='text'
                            value={props.editcard.title} name="title"
                            onChange={e => props.setEditCard(pre => ({ ...pre, title: e.target.value }))}
                        />
                    </Col>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Input.TextArea
                            rows={4} placeholder={'請輸入文章內容'} type='text'
                            value={props.editcard.content} name="content"
                            onChange={e => props.setEditCard(pre => ({ ...pre, content: e.target.value }))}
                        />
                    </Col> */}
                    {/* <Col span={8}></Col>
                    <Col span={16}>
                        <Upload
                            accept="image/png,image/jpeg"
                            customRequest={handleUpload}
                            listType="picture-card"
                            fileList={blog_filelist}
                            onPreview={handlePreview}
                            onRemove={e => showConfirm(e)}
                            // onChange={handleUpload} 
                            beforeUpload={false}
                            multiple
                        >
                            <div>
                                <PlusOutlined />
                                <div
                                    style={{
                                        marginTop: 8,
                                    }}
                                >
                                    上傳圖片
                                </div>
                            </div>
                        </Upload>
                    </Col> */}
                    {/* <Col span={8}></Col>
                        <Col span={16}>＊請注意圖片大小，限制在2MB以內</Col> */}
                {/* </> : null} */}
                {/* </> : null} */}
                {/* <Col span={8}>是否兼任行政人員</Col>
                <Col span={5}>
                    <Checkbox checked={check} onChange={e => {
                        setCheck(!check);
                    }}>是</Checkbox>
                </Col> */}

                {/* {check ? <>
                    <Col span={11}>
                        <Input placeholder={'請輸入職位名稱'} type='text'
                            value={props.editcard.position} name="position"
                            onChange={e => props.setEditCard(pre => ({ ...pre, position: e.target.value }))}
                        />
                    </Col>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Input.TextArea
                            rows={2} placeholder={'請輸入職務內容'} type='text'
                            value={props.editcard.adminstration_note} name="adminstration_note"
                            onChange={e => props.setEditCard(pre => ({ ...pre, adminstration_note: e.target.value }))}
                        />
                    </Col>
                </> : null} */}
            </Row>
        </AdminModal>
    </>)

}
export default AdminTeacherModal;